import script from "./POIHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./POIHeader.vue?vue&type=script&setup=true&lang=js"

import "./POIHeader.vue?vue&type=style&index=0&id=65611d7c&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/RJKESzs2/0/roolz/poi-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65611d7c"]])

export default __exports__